export default __webpack_public_path__ + "images/0c5ea8c47ff8ded9d0b7b62aa3797d24.png";